import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import dayjs from 'dayjs';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import React, { useState } from 'react';

import { useAccountingPeriod } from '../../context/AccountingPeriodContext';
import MajorBookByIdentifier from './components/MajorBookByIdentifier';

const MajorBookByIdentifierPage: React.FC<{
  transactional?: boolean;
  startDate?: Date;
  endDate?: Date;
}> = ({
  transactional = false,
  startDate: propStartDate,
  endDate: propEndDate,
}) => {
  const { startDate, endDate, setPeriod } = useAccountingPeriod();
  const [buttons, setButtons] = useState<CustomButtonProps[]>([]);

  const periodTitle =
    startDate != null || endDate != null
      ? `Período: ${startDate ? dayjs.utc(startDate).format('DD/MM/YYYY') : ''} - ${endDate ? dayjs.utc(endDate).format('DD/MM/YYYY') : ''}`
      : 'Libro auxiliar';

  return (
    <div>
      <HeaderWithActions
        icon={<CalendarMonthIcon color="primary" />}
        title={periodTitle}
        buttons={buttons}
      />
      <MajorBookByIdentifier
        isActive={true}
        transactional={transactional}
        propStartDate={
          propStartDate ?? (startDate ? new Date(startDate) : undefined)
        }
        propEndDate={propEndDate ?? (endDate ? new Date(endDate) : undefined)}
        onButtonsReady={setButtons}
        onPeriodChange={setPeriod}
      />
    </div>
  );
};

export default MajorBookByIdentifierPage;
